import React from "react";
import { StarRating } from "../../../components";
import { StarRating as StarRatingType } from "../../../@types";

interface StarRatingListItemProps {
  label: string;
  starRating?: StarRatingType;
  planYear: string;
}

const StarRatingListItem: React.FunctionComponent<StarRatingListItemProps> = props => {
  return (
    <li className="StarRatingListItem" role="listitem">
      <span className="ds-u-margin-bottom--1 ds-u-margin-right--2 ds-u-md-margin-bottom--0">
        {props.label}
      </span>
      <StarRating
        stars={props.starRating}
        includeLabel={false}
        planYear={props.planYear}
      />
    </li>
  );
};

export default StarRatingListItem;
